import { render, staticRenderFns } from "./CogAssist.vue?vue&type=template&id=28c2d85d&scoped=true&"
import script from "./CogAssist.vue?vue&type=script&lang=js&"
export * from "./CogAssist.vue?vue&type=script&lang=js&"
import style0 from "./CogAssist.vue?vue&type=style&index=0&id=28c2d85d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c2d85d",
  null
  
)

export default component.exports